export default "__VITE_ASSET__D0pGbGk1__"